var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _path13, _path14, _circle3, _path15, _path16, _circle4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle5, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6, _mask7, _g7, _path44, _circle6, _path45, _path46, _circle7, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _mask8, _g8, _mask9, _g9, _mask10, _g10, _mask11, _g11, _mask12, _g12, _mask13, _g13, _mask14, _g14, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 432 313"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 204,
    r: 36,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 189.6h12.6v12.6H21.6v-12.6zm0 16.2h12.6v12.6H21.6v-12.6zm16.2-16.2h12.6v12.6H37.8v-12.6zm0 16.2h12.6v12.6H37.8v-12.6z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392 300a40 40 0 100-80 40 40 0 000 80z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.3 260.01c0 1.57-.3 3.08-.82 4.47-1.39.53-2.9.81-4.47.81h-.02c-1.57 0-3.08-.28-4.47-.8-.52-1.4-.81-2.9-.81-4.48v-.02c0-1.57.29-3.08.8-4.47 1.4-.52 2.9-.81 4.48-.81h.02c1.57 0 3.08.29 4.47.81.52 1.4.81 2.9.81 4.47v.02zm15.58-3.54h-12.36l8.74-8.74a21.2 21.2 0 00-5-5l-8.73 8.75v-12.36c-1.16-.2-2.34-.3-3.52-.3H392c-1.18 0-2.36.1-3.52.3v12.36l-8.74-8.74a21.27 21.27 0 00-5 5l8.75 8.73h-12.36s-.3 2.32-.3 3.52v.02c0 1.18.1 2.36.3 3.52h12.36l-8.74 8.74a21.27 21.27 0 004.99 5l8.74-8.75v12.36c1.16.2 2.34.3 3.51.3h.03c1.18 0 2.36-.1 3.52-.3v-12.36l8.74 8.74a21.2 21.2 0 005-5l-8.75-8.73h12.36c.2-1.16.3-2.34.3-3.51v-.03c0-1.18-.1-2.36-.3-3.52z",
    fill: "#FC612E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224 309a36 36 0 100-72 36 36 0 000 72z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.8 269.96v17.22c0 1.11.9 2.02 2.02 2.02h28.36c1.11 0 2.02-.9 2.02-2.02v-17.25l-16.2 13.2-16.2-13.17z",
    fill: "#36D0FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M238.18 264.9l-2.03-1.15v-4.93c0-1.11-.9-2.02-2.03-2.02h-20.25c-1.11 0-2.02.9-2.02 2.02v4.93l-2.03 1.15c-1.04.54-2.02.9-2.02 2.03l16.2 13.16 16.2-13.16c0-1.12-1.04-1.56-2.02-2.03zm-8.1 6.08h-12.16v-2.03h12.16v2.03zm0-6.08h-12.16v-2.02h12.16v2.02z",
    fill: "#36D0FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195 236a40 40 0 100-80 40 40 0 000 80z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.2 170a9.8 9.8 0 01-2.24 7.03c-1.51 1.85-3.99 3.3-6.42 3.1-.32-2.52.9-5.15 2.3-6.8 1.56-1.86 4.2-3.24 6.37-3.33zm7.83 15.02c-.45.29-4.68 2.97-4.63 8.36.05 6.51 5.49 8.77 5.79 8.9h.01l-.01.04c-.13.4-1 3.27-2.98 6.22-1.8 2.68-3.67 5.35-6.62 5.4a7.27 7.27 0 01-3.34-.82 8.52 8.52 0 00-3.8-.93c-1.77 0-2.89.5-3.97.96-.93.4-1.84.8-3.1.85-2.85.1-5.01-2.9-6.83-5.57-3.72-5.46-6.55-15.44-2.74-22.17a10.55 10.55 0 018.94-5.52c1.59-.03 3.12.6 4.46 1.14 1.02.41 1.94.78 2.67.78.67 0 1.56-.36 2.6-.78 1.63-.65 3.62-1.45 5.68-1.24 1.41.06 5.37.58 7.9 4.36l-.03.02z",
    fill: "#6D7278"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M364 222a44 44 0 100-88 44 44 0 000 88z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.69 159.01a13.55 13.55 0 016.37 9.91h.08v1.52h-28.2v-1.52c.48-4.15 2.9-7.74 6.37-9.9l-1.57-3.03a1.49 1.49 0 01.7-2.03 1.6 1.6 0 012.11.67l1.58 3.04.4-.15a14.63 14.63 0 018.93 0l.41.15 1.58-3.03a1.6 1.6 0 012.11-.68c.78.37 1.1 1.28.7 2.03L371.7 159zm-13.98 5.38c0 .83.7 1.5 1.58 1.5.86 0 1.57-.67 1.57-1.5 0-.84-.7-1.51-1.57-1.52-.87 0-1.58.68-1.58 1.52zm11 1.5c-.86 0-1.57-.67-1.57-1.5 0-.84.7-1.51 1.57-1.52.88 0 1.58.68 1.58 1.52 0 .83-.7 1.5-1.57 1.5zM342 174.98a3.1 3.1 0 013.14-3.02 3.1 3.1 0 013.15 3.02v12.1a3.1 3.1 0 01-3.15 3.03 3.1 3.1 0 01-3.14-3.03v-12.1zm37.71 0a3.1 3.1 0 013.15-3.02 3.1 3.1 0 013.14 3.02v12.1a3.1 3.1 0 01-3.14 3.03 3.1 3.1 0 01-3.15-3.03v-12.1zm-29.85 13.62c0 2.5 2.1 4.53 4.71 4.53v6.05a3.1 3.1 0 003.14 3.03 3.1 3.1 0 003.15-3.03v-6.05h6.28v6.05a3.1 3.1 0 003.15 3.03 3.1 3.1 0 003.14-3.03v-6.05c2.6 0 4.71-2.03 4.71-4.53v-16.64h-28.28v16.64z",
    fill: "#3ECF8E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 269,
    r: 44,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M305.85 249.2h2.84v9.73h14.74c.98-.05 2.3.23 2.28 1.47.18 6.16 0 12.32.08 18.48 0 1.08 0 2.8-1.48 2.82-5.2.18-10.43 0-15.64.07V291h-2.95c-7.22-1.33-14.47-2.57-21.72-3.87V253.1c7.28-1.3 14.57-2.57 21.85-3.9z",
    fill: "#0071C5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.7 260.38h15.8a2.4 2.4 0 01-.8 1.67c-3.15 3-6.3 6.02-9.43 9.03-1.88-1.72-3.73-3.55-5.58-5.32v-5.38zm-14.52 1.78a5.56 5.56 0 016.94 3.07c1.56 3.64 1.33 8.64-1.75 11.4-2.83 2.45-7.58 1.07-8.87-2.46-1.7-4.07-.88-10.34 3.68-12z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M315.77 271.52c2.86-2.78 5.74-5.54 8.61-8.3v17.1h-15.69v-12.71c1.78 1.6 3.36 3.44 5.25 4.91.78.13 1.3-.56 1.83-1z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M294.64 265.09a2.6 2.6 0 013.44 1.29 8.68 8.68 0 01.33 6.3c-.45 1.45-1.97 2.64-3.48 2.07-1.87-.6-2.44-2.87-2.46-4.65-.03-1.77.38-4.13 2.17-5.01z",
    fill: "#0071C5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 110,
    r: 36,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M319.67 92h2.32v3.18c4.16.04 8.32-.04 12.47.04a1.35 1.35 0 011.5 1.52c.06 7.84 0 15.7.04 23.52-.04.8.07 1.7-.38 2.41-.57.4-1.3.36-1.96.4h-11.67v3.13h-2.4c-5.94-1.09-11.86-2.1-17.79-3.17V95.2c5.95-1.07 11.91-2.1 17.87-3.19z",
    fill: "#2A5699"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322 96.38h12.81v25.46H322v-3.19h10.1v-1.6H322v-1.98h10.1v-1.6H322v-1.98h10.1v-1.6H322v-2.02h10.1v-1.55H322v-2h10.1v-1.58H322v-1.99h10.1v-1.59H322v-2.78zm-12.16 7.03l2.22-.12c.52 2.69 1.04 5.37 1.6 8.05.44-2.77.93-5.52 1.4-8.28.78-.02 1.55-.07 2.33-.12-.88 3.86-1.65 7.75-2.61 11.58-.65.34-1.6 0-2.39.04-.54-2.64-1.14-5.26-1.6-7.9-.45 2.57-1.05 5.12-1.56 7.67l-2.25-.14c-.65-3.5-1.4-6.98-2.01-10.49l2-.09c.41 2.54.86 5.06 1.21 7.6.54-2.6 1.1-5.2 1.66-7.8z",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 126,
    r: 40,
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.02 135.23a5.96 5.96 0 01-9.02-5.1 6 6 0 011.52-4.04 5.84 5.84 0 013.77-1.93 7.26 7.26 0 017.28-8.35c1.32 0 2.5.3 3.55.94.85-1.4 2.02-2.57 3.41-3.42a9.45 9.45 0 014.78-1.33 9.46 9.46 0 019.3 7.8h-.52c-.86 0-1.6.12-2.26.37a9.07 9.07 0 00-6.74-2.87 9.72 9.72 0 00-8.36 4.63 8.31 8.31 0 00-1.07 2.73c-.66.14-1.3.33-1.87.58a6.45 6.45 0 00-2.36 1.85c-.6.69-1.08 1.5-1.38 2.4a8.94 8.94 0 00.08 5.9l-.11-.16zm30.89-6.9c2.89.73 4.25 2.43 4.08 5.12-.17 2.7-1.73 4.21-4.69 4.55H43.95c-3.86-.51-5.75-2.51-5.69-6 .07-3.5 2.03-5.44 5.89-5.77.5-3.75 2.41-6.07 5.72-6.95 3.3-.91 6.12.1 8.45 3.09.8-.67 1.81-.94 3.03-.86 1.22.08 2.26.33 3.1.8 1.1.58 1.99 1.41 2.57 2.46.57 1.05.88 2.23.88 3.53v.04z",
    fill: "#0274BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142 310a44 44 0 100-88 44 44 0 000 88z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142 288a22 22 0 0022-22h-11a11 11 0 01-11 11v11z",
    fill: "#34A853"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164 266a22 22 0 00-22-22v11a11 11 0 0111 11h11z",
    fill: "#4285F4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142 288a22 22 0 01-22-22h11a11 11 0 0011 11v11z",
    fill: "#F4B400"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120 266a22 22 0 0122-22v11a11 11 0 00-11 11h-11z",
    fill: "#EA4335"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142 255a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
    fill: "#EA4335"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142 252.25a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120 266a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0z",
    fill: "#F4B400"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.75 266a2.75 2.75 0 105.5 0 2.75 2.75 0 00-5.5 0z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136.5 282.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0z",
    fill: "#34A853"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139.25 282.5a2.75 2.75 0 105.5 0 2.75 2.75 0 00-5.5 0z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153 266a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0z",
    fill: "#4285F4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M155.75 266a2.75 2.75 0 105.5 0 2.75 2.75 0 00-5.5 0z",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 274,
    r: 36,
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 261c0-.28.22-.5.5-.5h32c.28 0 .5.22.5.5v26a.5.5 0 01-.5.5H44a.5.5 0 01-.5-.5v-26z",
    stroke: "#09F",
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.87 273.33h-4.39l-.87 2.17H48l4.62-10.5h2.06l4.64 10.5h-2.57l-.88-2.17zm-.84-2.08l-1.35-3.31-1.35 3.31h2.7zm4.85-6.25h4.7c1.14 0 2.01.29 2.63.87a3 3 0 01.93 2.33c0 .97-.31 1.75-.94 2.33a3.7 3.7 0 01-2.61.87h-2.1v4.1h-2.6V265zm4.36 4.34c.98 0 1.47-.37 1.47-1.11 0-.37-.12-.65-.36-.84-.23-.2-.6-.3-1.1-.3h-1.76v2.25h1.75zm5.15-4.34H72v10.5h-2.61V265z",
    fill: "#0091FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M231 160a48 48 0 100-96 48 48 0 000 96z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218.45 118.18c0 2.78-2.12 5.03-4.73 5.03-2.6 0-4.72-2.25-4.72-5.03 0-2.78 2.11-5.03 4.72-5.03h4.73v5.03zm2.36 0c0-2.78 2.11-5.03 4.72-5.03s4.73 2.25 4.73 5.03v12.57c0 2.78-2.12 5.03-4.73 5.03-2.6 0-4.72-2.25-4.72-5.03v-12.57z",
    fill: "#E01E5A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M225.53 98.06c-2.6 0-4.72-2.25-4.72-5.03 0-2.78 2.11-5.03 4.72-5.03s4.73 2.25 4.73 5.03v5.03h-4.73zm0 2.51c2.61 0 4.73 2.26 4.73 5.03 0 2.78-2.12 5.03-4.73 5.03h-11.8c-2.62 0-4.73-2.25-4.73-5.03 0-2.77 2.11-5.03 4.72-5.03h11.81z",
    fill: "#36C5F0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M244.43 105.6c0-2.77 2.11-5.03 4.72-5.03s4.73 2.26 4.73 5.03c0 2.78-2.12 5.03-4.72 5.03h-4.73v-5.03zm-2.36 0c0 2.78-2.12 5.03-4.73 5.03-2.6 0-4.72-2.25-4.72-5.03V93.03c0-2.78 2.12-5.03 4.72-5.03 2.61 0 4.73 2.25 4.73 5.03v12.57z",
    fill: "#2EB67D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M237.34 125.72c2.61 0 4.73 2.26 4.73 5.03 0 2.78-2.12 5.03-4.72 5.03-2.61 0-4.73-2.25-4.73-5.03v-5.03h4.72zm0-2.51c-2.6 0-4.72-2.25-4.72-5.03 0-2.78 2.12-5.03 4.72-5.03h11.81c2.61 0 4.73 2.25 4.73 5.03 0 2.78-2.12 5.03-4.73 5.03h-11.8z",
    fill: "#ECB22E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112 225a40 40 0 100-80 40 40 0 000 80z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M96.83 171.97a20 20 0 0132.98 3.96h-15.49c-2.79 0-4.59-.07-6.54.96a9.24 9.24 0 00-4.63 6.07l-6.32-11z",
    fill: "#EA4335"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M105.35 185a6.66 6.66 0 1013.3-.01 6.66 6.66 0 00-13.3.01z",
    fill: "#4285F4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M114.57 193.7a8.96 8.96 0 01-10.48-4.25 6158.8 6158.8 0 01-8.85-15.37c-7.68 11.77-1.06 27.8 12.88 30.54l6.45-10.92z",
    fill: "#34A853"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M118.17 178.35a9.1 9.1 0 011.68 11.2c-1.59 2.73-6.65 11.27-9.1 15.41 14.36.88 24.83-13.19 20.1-26.61h-12.68z",
    fill: "#FBBC05"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284 80a32 32 0 100-64 32 32 0 000 64z",
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-5.6-4-4-5.6z",
    fill: "#0F9D58"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.6 47.6v11.6h12.8V47.6h-12.8zm5.6 10h-4v-2h4v2zm0-3.2h-4v-2h4v2zm0-3.2h-4v-2h4v2zm5.6 6.4h-4v-2h4v2zm0-3.2h-4v-2h4v2zm0-3.2h-4v-2h4v2z",
    fill: "#F1F1F1"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.9 39.3l8.9 8.9V40l-8.9-.7z",
    fill: "url(#icon-group_svg__paint0_linear)"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__d",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-group_svg__pattern0)",
    d: "M285.6 28.8H300v14.45h-14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4v7.2a2.4 2.4 0 002.4 2.4h7.2l-9.6-9.6z",
    fill: "#87CEAC"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__e",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.6 30.4a2.4 2.4 0 00-2.4 2.4v.2a2.4 2.4 0 012.4-2.4h13.6v-.2h-13.6z",
    fill: "#fff"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__f",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.4 65.4h-20.8a2.4 2.4 0 01-2.4-2.4v.2a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V63a2.4 2.4 0 01-2.4 2.4z",
    fill: "#263238",
    fillOpacity: 0.2
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__g",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 30,
    width: 26,
    height: 36
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.6 40a2.4 2.4 0 01-2.4-2.4v.2a2.4 2.4 0 002.4 2.4h7.2V40h-7.2z",
    fill: "#263238",
    fillOpacity: 0.1
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M287.2 30.4h-13.6a2.4 2.4 0 00-2.4 2.4v30.4a2.4 2.4 0 002.4 2.4h20.8a2.4 2.4 0 002.4-2.4V40l-9.6-9.6z",
    fill: "url(#icon-group_svg__paint1_radial)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 101,
    r: 36,
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377 89.75l13.85-1.13v11.25H377V89.75zm16.15-1.12L407 87.5v12.38h-13.85V88.63zM377 102.13h13.85v11.25L377 112.25v-10.13z",
    fill: "#2F80ED"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M393.15 102.13H407v12.37l-13.85-1.13v-11.25z",
    fill: "#2F80ED"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 188,
    r: 40,
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#8682f8",
    d: "M276.476 168.204a20.14 20.14 0 00-17.8 16.82 18.78 18.78 0 00.86 9.6 20 20 0 1016.94-26.42m2.4 3.06a29.9 29.9 0 012.66 4.24 45.7 45.7 0 011.94 4.22l.06.22h-10.2l.06-.22a25.34 25.34 0 011.5-3.36 25.68 25.68 0 01.9-1.66c0-.16 2-3.28 2.26-3.5.24-.2.6-.18.82.06m-4.84.48a57.66 57.66 0 00-1 1.76 86.88 86.88 0 00-2.14 4.34l-.48 1.22-.32.88h-6.54l.24-.46a17.46 17.46 0 019.88-7.7c.2-.08.36-.1.36-.04m9.52.16a19.22 19.22 0 015.68 3.08 15.18 15.18 0 014 4.84c0 .1-.3.12-3.22.12h-3.24l-.26-.7a21.8 21.8 0 00-.72-1.84l-.34-.74c-.6-1.34-1.2-2.44-2.12-4.02-.64-1.1-.66-1.04.22-.74m-14.4 11.08c.06.04.08.12.06.2-.14.34-.4 1.94-.54 3.18-.18 1.7 0 4.32.4 6.18.2.8.6.72-3.32.74-1.88 0-3.46 0-3.5-.04l-.2-.54a17.38 17.38 0 01-.24-8.12c.12-.66.4-1.56.5-1.6.12-.1 6.7-.1 6.84 0m15.34 0c.06.02.14.2.18.38l.2.9a18.54 18.54 0 01-.28 8.86l-.08.18h-6.02c-6.74 0-6.18.06-6.32-.6a18.08 18.08 0 01-.14-8.52l.16-.74c.12-.6-.4-.54 6.22-.54 3.3 0 6.02.04 6.08.08m10.08 0c.14.08.4 1.02.64 2.4.42 2.24.16 5.94-.52 7.7l-.1.22-3.46-.02c-3 0-3.46-.04-3.44-.14l.12-.72a21.24 21.24 0 00-.14-9.44c.06-.1 6.74-.12 6.9 0m-24.06 14.38a41.4 41.4 0 003.14 6.4c.2.38.36.7.34.72-.26.28-5.34-2.2-5.88-2.86l-.44-.36a24.22 24.22 0 01-2.76-2.84c-.14-.1-1.28-1.92-1.28-2.02 0-.12.3-.14 3.22-.14h3.24l.4 1.1m13-.92c-.54 1.78-3.6 7.42-4.6 8.52-.26.28-.7.24-.96-.08a32.6 32.6 0 01-2.16-3.4c-.98-1.7-2.38-4.7-2.38-5.08 0-.14.2-.14 5.08-.14h5.1l-.06.18m9.8-.12a20.48 20.48 0 01-1.64 2.46 28.06 28.06 0 01-2.92 2.84c-.58.7-5.6 3.14-5.88 2.86-.02 0 .2-.46.52-.98 1.08-1.82 2.52-4.84 3.16-6.62l.22-.62h3.28c1.8 0 3.26.02 3.26.06",
    id: "icon-group_svg__path552",
    fillRule: "evenodd",
    strokeWidth: 0.2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80 88a44 44 0 100-88 44 44 0 000 88z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M61.33 58.14l1.94 3.38c.4.7.98 1.27 1.66 1.67l6.93-12.08H58c0 .79.2 1.57.6 2.28l2.73 4.75z",
    fill: "#0066DA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36.9l-6.93-12.1a4.6 4.6 0 00-1.66 1.68L58.6 48.83c-.4.7-.61 1.5-.61 2.28h13.86L80 36.89z",
    fill: "#00AC47"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36.9l6.93-12.09a4.4 4.4 0 00-2.27-.6h-9.32c-.8 0-1.59.22-2.27.6L80 36.89z",
    fill: "#00832D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M88.14 51.1H71.86l-6.93 12.1c.68.4 1.46.6 2.27.6h25.6c.8 0 1.59-.23 2.27-.6l-6.93-12.1z",
    fill: "#2684FC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M95.07 63.2a4.6 4.6 0 001.66-1.68l.8-1.4 3.86-6.73c.4-.7.61-1.5.61-2.28H88.16l6.9 12.08z",
    fill: "#EA4335"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37.66l-6.4-11.17a4.6 4.6 0 00-1.67-1.68L80 36.9l8.14 14.22h13.84c0-.79-.2-1.57-.6-2.28L95 37.66z",
    fill: "#FFBA00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M141 148a40 40 0 100-80 40 40 0 000 80z",
    fill: "#fff"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__h",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-7-5-5-7z",
    fill: "#4285F4"
  }))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__i",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.88 97.12L157 108.24V98l-11.12-.88z",
    fill: "url(#icon-group_svg__paint2_linear)"
  }))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__j",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133 118h16v-2h-16v2zm0 4h12v-2h-12v2zm0-14v2h16v-2h-16zm0 6h16v-2h-16v2z",
    fill: "#F1F1F1"
  }))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__k",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-group_svg__pattern1)",
    d: "M143 84h18v18.06h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 86v9a3 3 0 003 3h9l-12-12z",
    fill: "#A1C2FA"
  }))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__l",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 86a3 3 0 00-3 3v.25a3 3 0 013-3h17V86h-17z",
    fill: "#fff"
  }))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__m",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 129.75h-26a3 3 0 01-3-3v.25a3 3 0 003 3h26a3 3 0 003-3v-.25a3 3 0 01-3 3z",
    fill: "#1A237E",
    fillOpacity: 0.2
  }))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "icon-group_svg__n",
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 86,
    width: 33,
    height: 44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-group_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148 98a3 3 0 01-3-3v.25a3 3 0 003 3h9V98h-9z",
    fill: "#1A237E",
    fillOpacity: 0.1
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M145 86h-17a3 3 0 00-3 3v38a3 3 0 003 3h26a3 3 0 003-3V98l-12-12z",
    fill: "url(#icon-group_svg__paint3_radial)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M181 77a36 36 0 100-72 36 36 0 000 72z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 53.57h-31.45a2.24 2.24 0 01-2.25-2.22v-22.4c0-1.21 1-2.22 2.25-2.22h31.45c1.22 0 2.25.98 2.25 2.21v22.41c0 1.24-1 2.22-2.25 2.22z",
    fill: "#E3E3E3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M167.5 53.57l13.44-10.67.1-.57-13.87-9.84-.03 20.6.35.48z",
    fill: "#231F20"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M165.25 53.57a2.22 2.22 0 01-2.25-2.22V28.91c0-1.23 1-1.46 2.25-1.46s2.25.26 2.25 1.46v24.66h-2.25z",
    fill: "#D54B3D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M165.25 27.77c1.6 0 1.92.48 1.92 1.14v24.34h-1.92a1.92 1.92 0 01-1.93-1.9V28.91c0-.7.32-1.14 1.93-1.14zm0-.32c-1.25 0-2.25.26-2.25 1.46v22.44c0 1.24 1 2.22 2.25 2.22h2.25V28.9c0-1.23-1-1.46-2.25-1.46z",
    fill: "#D72B27"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 53.57h-2.24V28.85c0-1.24 1-1.4 2.24-1.4 1.26 0 2.25.16 2.25 1.4v22.53c0 1.2-1 2.19-2.25 2.19z",
    fill: "#D54B3D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 27.77c1.45 0 1.93.29 1.93 1.08v22.53c0 1.05-.87 1.9-1.93 1.9h-1.92V28.85c0-.83.48-1.08 1.92-1.08zm0-.32c-1.25 0-2.24.16-2.24 1.4V53.6h2.24c1.26 0 2.25-.98 2.25-2.22V28.85c0-1.24-1-1.4-2.25-1.4z",
    fill: "#D72B27"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M187.07 53.57L163.2 29.83l1.26.5 16.62 11.81 17.88-12.93v22.17c0 1.2-1 2.19-2.25 2.19h-9.63z",
    fill: "url(#icon-group_svg__paint4_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M180.95 42.9l-16.98-12.15c-1-.73-1.29-2.12-.55-3.1a2.35 2.35 0 013.21-.48l14.35 10.29 14.44-10.42c1-.72 2.4-.5 3.15.51.74.98.51 2.37-.52 3.1l-17.1 12.25z",
    fill: "#D54B3D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7 26.92c.62 0 1.2.28 1.58.79.6.85.41 2.02-.42 2.66l-16.91 12.15-16.79-12.03c-.87-.63-1.1-1.83-.48-2.65.35-.48.96-.8 1.6-.8.42 0 .84.13 1.16.38l14.31 10.26.2.13.19-.13 14.4-10.41c.36-.23.75-.35 1.17-.35zm0-.32c-.44 0-.93.13-1.31.41l-14.44 10.42-14.35-10.3a2.26 2.26 0 00-1.35-.4c-.7 0-1.41.31-1.86.92-.7.98-.42 2.37.58 3.1l16.98 12.18 17.07-12.28a2.23 2.23 0 00-1.31-4.05z",
    fill: "#D72B27"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-group_svg__paint0_linear",
    x1: 292.35,
    y1: 40.06,
    x2: 292.35,
    y2: 48.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-group_svg__paint2_linear",
    x1: 151.44,
    y1: 98.08,
    x2: 151.44,
    y2: 108.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-group_svg__paint4_linear",
    x1: 163.19,
    y1: 41.39,
    x2: 198.96,
    y2: 41.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-group_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.01 31.1) scale(41.2796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-group_svg__paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(51.5995 0 0 51.3018 126.01 86.87)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

export default __webpack_public_path__ + "static/icon-group.b2311a70.svg";
export { SvgIconGroup as ReactComponent };